import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppService} from '../../../services/app.service';

@Component({
  selector: 'app-empty-or-noaccess',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class EmptyOrNoAccessComponent implements OnInit {
  @Input() title = '';
  @Input() icon = '';
  @Input() height = '100%';

  appService: AppService;

  constructor(
    appService: AppService
  ) {
    this.appService = appService;
  }

  ngOnInit(): void {

  }

  getIcon() {
    return `assets/icons/${this.icon}.svg`;
  }
}
